export class CashRegisterXReportLocalRequest {
    cashRegisterId?: number;
    accessToken?: string;
} 